import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/apps/assets/images/goodTooth.png'
import _imports_1 from '@/apps/assets/images/pdfStar.png'
import _imports_2 from '@/apps/assets/images/badTooth.png'
import _imports_3 from '@/apps/assets/images/averageTooth.png'


const _withScopeId = n => (_pushScopeId("data-v-d179a25a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "plaque-condition" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "",
  class: "card__image",
  src: _imports_0
}, null, -1))
const _hoisted_3 = {
  key: 0,
  class: "card__title text"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Текущий ")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" уровень ")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" налёта ")
const _hoisted_9 = [
  _hoisted_4,
  _hoisted_5,
  _hoisted_6,
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  class: "card__title tex"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Стандарт ")
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" здоровой ")
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" гигиены ")
const _hoisted_16 = [
  _hoisted_11,
  _hoisted_12,
  _hoisted_13,
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "card__status title" }, "0-10%", -1))
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<div class=\"card__congratulation\" data-v-d179a25a><img alt=\"star\" src=\"" + _imports_1 + "\" data-v-d179a25a><p class=\"card__text small-text subtitle\" data-v-d179a25a> Поздравляем! Ваша <br data-v-d179a25a> гигиена лучше, чем у <br data-v-d179a25a> 60% населения! </p></div><p class=\"card__text small-text subtitle\" data-v-d179a25a> Расчет выполнен с <br data-v-d179a25a> помощью искусственного <br data-v-d179a25a> интеллекта DIANA и <br data-v-d179a25a> отражает ваш текущий <br data-v-d179a25a> уровень налета — <span data-v-d179a25a>0-10%</span></p>", 2)
const _hoisted_20 = {
  key: 3,
  class: "card__text small-text subtitle"
}
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Здоровый уровень налета ")
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" составляет 0-10% без ")
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" учета показания индексов. ")
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" И не представляет ")
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" опасности для здоровья ")
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" десен и зубов. ")
const _hoisted_32 = [
  _hoisted_21,
  _hoisted_22,
  _hoisted_23,
  _hoisted_24,
  _hoisted_25,
  _hoisted_26,
  _hoisted_27,
  _hoisted_28,
  _hoisted_29,
  _hoisted_30,
  _hoisted_31
]
const _hoisted_33 = {
  key: 0,
  alt: "",
  class: "card__image",
  src: _imports_2
}
const _hoisted_34 = {
  key: 1,
  alt: "",
  class: "card__image",
  src: _imports_3
}
const _hoisted_35 = {
  key: 2,
  class: "card__title text"
}
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" Текущий ")
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" уровень ")
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" налёта ")
const _hoisted_41 = [
  _hoisted_36,
  _hoisted_37,
  _hoisted_38,
  _hoisted_39,
  _hoisted_40
]
const _hoisted_42 = {
  key: 3,
  class: "card__title text"
}
const _hoisted_43 = /*#__PURE__*/_createTextVNode(" Уровень ")
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_45 = /*#__PURE__*/_createTextVNode(" налёта при ")
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_47 = /*#__PURE__*/_createTextVNode(" 1 пропуске ")
const _hoisted_48 = [
  _hoisted_43,
  _hoisted_44,
  _hoisted_45,
  _hoisted_46,
  _hoisted_47
]
const _hoisted_49 = {
  key: 4,
  class: "card__status title"
}
const _hoisted_50 = {
  key: 5,
  class: "card__status title"
}
const _hoisted_51 = {
  key: 6,
  class: "card__text small-text subtitle"
}
const _hoisted_52 = /*#__PURE__*/_createTextVNode(" Пропуск следующего ")
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_54 = /*#__PURE__*/_createTextVNode(" визита приведет к росту ")
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_56 = /*#__PURE__*/_createTextVNode(" налета на 10-15% и может ")
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_58 = /*#__PURE__*/_createTextVNode(" достигнуть 15-25%. ")
const _hoisted_59 = [
  _hoisted_52,
  _hoisted_53,
  _hoisted_54,
  _hoisted_55,
  _hoisted_56,
  _hoisted_57,
  _hoisted_58
]
const _hoisted_60 = {
  key: 7,
  class: "card__text small-text subtitle"
}
const _hoisted_61 = /*#__PURE__*/_createTextVNode(" Расчет выполнен с ")
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_63 = /*#__PURE__*/_createTextVNode(" помощью искусственного ")
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_65 = /*#__PURE__*/_createTextVNode(" интеллекта DIANA и ")
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_67 = /*#__PURE__*/_createTextVNode(" отражает ваш текущий ")
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_69 = /*#__PURE__*/_createTextVNode(" уровень налета — ")
const _hoisted_70 = { key: 0 }
const _hoisted_71 = { key: 1 }
const _hoisted_72 = /*#__PURE__*/_createStaticVNode("<div class=\"card\" data-v-d179a25a><img alt=\"\" class=\"card__image\" src=\"" + _imports_2 + "\" data-v-d179a25a><h3 class=\"card__title text\" data-v-d179a25a> Уровень <br data-v-d179a25a> налёта при <br data-v-d179a25a> пропусках </h3><p class=\"card__status title\" data-v-d179a25a>&gt; 30%</p><p class=\"card__text small-text subtitle\" data-v-d179a25a> Пропуск следующих <br data-v-d179a25a> визитов приведет к <br data-v-d179a25a> большему росту и может <br data-v-d179a25a> достигнуть &gt; 30%, что <br data-v-d179a25a> значительно увеличит риск <br data-v-d179a25a> развития заболевания — <br data-v-d179a25a> кариеса. </p></div>", 1)

import { computed } from 'vue'

interface Props {
  totalPlaque: number
}


export default /*#__PURE__*/_defineComponent({
  props: {
    totalPlaque: null
  },
  setup(__props: any) {

const props = __props as {
  totalPlaque: number
}



const totalPlaque = computed<number>(() => props.totalPlaque)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([{ card_healthful: _unref(totalPlaque) < 11 }, "card"])
    }, [
      _hoisted_2,
      (_unref(totalPlaque) < 11)
        ? (_openBlock(), _createElementBlock("h3", _hoisted_3, _hoisted_9))
        : (_openBlock(), _createElementBlock("h3", _hoisted_10, _hoisted_16)),
      _hoisted_17,
      (_unref(totalPlaque) < 11)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _hoisted_18
          ], 64))
        : (_openBlock(), _createElementBlock("p", _hoisted_20, _hoisted_32))
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass([{
        card_warning: _unref(totalPlaque) >= 11 && _unref(totalPlaque) < 30,
        card_danger: _unref(totalPlaque) >= 30,
      }, "card"])
    }, [
      (_unref(totalPlaque) >= 30)
        ? (_openBlock(), _createElementBlock("img", _hoisted_33))
        : (_openBlock(), _createElementBlock("img", _hoisted_34)),
      (_unref(totalPlaque) >= 11)
        ? (_openBlock(), _createElementBlock("h3", _hoisted_35, _hoisted_41))
        : (_openBlock(), _createElementBlock("h3", _hoisted_42, _hoisted_48)),
      (_unref(totalPlaque) < 30)
        ? (_openBlock(), _createElementBlock("p", _hoisted_49, "11-30%"))
        : (_openBlock(), _createElementBlock("p", _hoisted_50, "> 30%")),
      (_unref(totalPlaque) < 11)
        ? (_openBlock(), _createElementBlock("p", _hoisted_51, _hoisted_59))
        : (_openBlock(), _createElementBlock("p", _hoisted_60, [
            _hoisted_61,
            _hoisted_62,
            _hoisted_63,
            _hoisted_64,
            _hoisted_65,
            _hoisted_66,
            _hoisted_67,
            _hoisted_68,
            _hoisted_69,
            (_unref(totalPlaque) >= 11 && _unref(totalPlaque) < 30)
              ? (_openBlock(), _createElementBlock("span", _hoisted_70, "11-30%"))
              : (_openBlock(), _createElementBlock("span", _hoisted_71, ">30%"))
          ]))
    ], 2),
    _hoisted_72
  ]))
}
}

})